import React from 'react'
import PublicPageSF from '../../templates/PublicPageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import LinkSocialUserSF from '../../components/login/LinkSocialUserSF'

const LinkSocialUserPageUI = ({context, privacy, messageList, provider}) =>
  <PublicPageSF context={context} className='pg_link_usr' backLink='/'
    messageList={messageList} headerMessageKey='c_link_social_acct' headerMessageArgs={[provider]}
  >
    <PageTitleUI context={context} goBack={true} backLink='/'
      messageList={messageList} titleMessageKey='c_link_social_acct' titleMessageArgs={[provider]}
    />
    <LinkSocialUserSF context={context} messageList={messageList} provider={provider} />
  </PublicPageSF>

export default LinkSocialUserPageUI
